import { AlertTitle, useTheme } from '@mui/material';
import { memo, useMemo } from 'react';
import { Icon } from '../icon';
import type { AlertProps as Props } from './types';
import { Alert as AlertBase } from '@mui/material';

export const Alert = memo(
  ({
    className,
    title,
    children,
    label,
    message,
    // showHelp,
    actionButton,
    onClose,
    hideHeader,
    icon,
    ...props
  }: Props) => {
    const theme = useTheme();

    const action = useMemo(() => {
      if (actionButton) {
        return actionButton;
      }
      if (onClose) {
        return (
          <Icon name="close" size={20} color="grey.600" onClick={onClose} />
        );
      }
      return null;
    }, [actionButton, onClose]);

    const titleComponent = useMemo(() => {
      if (title) {
        return <AlertTitle>{title}</AlertTitle>;
      }
      return null;
    }, [title]);

    return (
      <AlertBase action={action} icon={icon} {...props}>
        {titleComponent}
        {message ?? children}
      </AlertBase>
    );

    // return (
    //   <Styled.Wrapper
    //     className={classnames('Alert', className)}
    //     icon={false}
    //     sx={{
    //       border: (p) =>
    //         `1px solid ${p.palette[props.severity ?? 'info'][200]}`,
    //     }}
    //     {...props}
    //   >
    //     {!hideHeader && (
    //       <Styled.Header>
    //         <Styled.HeaderLeft>
    //           {icon && (
    //             <Styled.IconWrapper
    //               sx={{
    //                 border: (p) =>
    //                   `1px solid ${p.palette[props.severity ?? 'info'][200]}`,
    //               }}
    //             >
    //               <Icon
    //                 name={icon}
    //                 size={18}
    //                 color={theme.palette[props.severity ?? 'info'][500]}
    //               />
    //             </Styled.IconWrapper>
    //           )}
    //           <Typography variant="body3" fontWeight={600} color="grey.600">
    //             {title}
    //           </Typography>
    //           {/* {label && label} */}
    //         </Styled.HeaderLeft>
    //         <Styled.HeaderRight>
    //           {onClose && (
    //             <Icon
    //               name="close"
    //               size={20}
    //               color="grey.600"
    //               onClick={onClose}
    //               sxx={{ cursor: 'pointer' }}
    //             />
    //           )}
    //         </Styled.HeaderRight>
    //       </Styled.Header>
    //     )}
    //     <Typography
    //       fontWeight={700}
    //       color={props.severity ?? 'info'}
    //       variant="body3"
    //     >
    //       {message}
    //     </Typography>
    //     {(showHelp || actionButton) && (
    //       <Styled.Footer>
    //         {showHelp && <AlertHelp />}
    //         {actionButton && actionButton}
    //       </Styled.Footer>
    //     )}
    //   </Styled.Wrapper>
    // );
  }
);

Alert.displayName = 'Alert';
